import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Toast, ToastType } from '../models/toast.model';

@Injectable({
	providedIn: 'root',
})
export class ToasterService {
	private toastsSubject = new BehaviorSubject<Toast[]>([]);
	public toasts$ = this.toastsSubject.asObservable();

	showToast(message: string, type: ToastType, options?: Partial<Toast>): void {
		if (options?.unique && !this.checkUnique(message)) {
			return;
		}

		const toast = Toast.create({
			id: this.generateId(),
			message,
			type,
			...options,
		});

		const currentToasts = this.toastsSubject.value;
		this.toastsSubject.next([...currentToasts, toast]);
	}

	checkUnique(message: string): boolean {
		const currentToasts = this.toastsSubject.value;
		return !currentToasts.some((toast) => toast.message === message);
	}

	removeToast(id: string): void {
		const currentToasts = this.toastsSubject.value;
		const filteredToasts = currentToasts.filter((toast) => toast.id !== id);
		this.toastsSubject.next(filteredToasts);
	}

	showSuccess(message: string, options?: Partial<Toast>): void {
		this.showToast(message, 'success', options);
	}

	showWarning(message: string, options?: Partial<Toast>): void {
		this.showToast(message, 'warning', options);
	}

	showInfo(message: string, options?: Partial<Toast>): void {
		this.showToast(message, 'info', options);
	}

	showError(message: string, options?: Partial<Toast>): void {
		this.showToast(message, 'error', options);
	}

	clearAll(): void {
		this.toastsSubject.next([]);
	}

	private generateId(): string {
		return Date.now().toString(36) + Math.random().toString(36).substr(2);
	}
}
